"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _io = require("react-icons/io5");

var _DqButton = _interopRequireDefault(require("../../elements/DqButton/DqButton"));

var _DqDialog = _interopRequireDefault(require("./DqDialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const DqAlertDialog = ({
  actionsCancelText,
  actionsConfirmText,
  hideCancelBtn,
  message,
  title,
  toggleEl,
  type = "error",
  backdropProps,
  handleOnCancel,
  handleOnOpen,
  handleOnClose,
  handleOnConfirm
}) => {
  const [showAlertDialog, setShowAlertDialog] = (0, _react.useState)(!toggleEl);
  const iconBgClasses = {
    error: "dq-bg-red-100",
    warning: "dq-bg-orange-100",
    info: "dq-bg-blue dq-bg-opacity-30",
    success: "dq-bg-green-100"
  };
  const iconClasses = {
    error: "dq-text-red",
    warning: "dq-text-orange-300",
    info: "dq-text-blue",
    success: "dq-text-green"
  };
  const icon = {
    error: /*#__PURE__*/_react.default.createElement(_io.IoWarningOutline, {
      className: (0, _classnames.default)("dq-h-6 dq-w-6", iconClasses[type])
    }),
    warning: /*#__PURE__*/_react.default.createElement(_io.IoWarningOutline, {
      className: (0, _classnames.default)("dq-h-6 dq-w-6", iconClasses[type])
    }),
    info: /*#__PURE__*/_react.default.createElement(_io.IoInformationCircleOutline, {
      className: (0, _classnames.default)("dq-h-6 dq-w-6", iconClasses[type])
    }),
    success: /*#__PURE__*/_react.default.createElement(_io.IoCheckmarkCircleOutline, {
      className: (0, _classnames.default)("dq-h-6 dq-w-6", iconClasses[type])
    })
  };

  const handleAlertOnClose = e => {
    e.stopPropagation();
    setShowAlertDialog(false);

    if (handleOnClose) {
      handleOnClose();
    }
  };

  const handleAlertOnCancel = e => {
    e.stopPropagation();
    setShowAlertDialog(false);

    if (handleOnCancel) {
      handleOnCancel();
    }
  };

  const handleAlertOnConfirm = e => {
    e.stopPropagation();
    setShowAlertDialog(false);
    handleOnConfirm();
  };

  const handleToggleOnClick = e => {
    e.stopPropagation();
    setShowAlertDialog(true);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, toggleEl && /*#__PURE__*/_react.default.cloneElement(toggleEl, {
    onClick: handleToggleOnClick
  }), showAlertDialog && /*#__PURE__*/_react.default.createElement(_DqDialog.default, {
    handleOnClose: handleAlertOnClose,
    handleOnOpen: handleOnOpen,
    backdropProps: backdropProps
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dq-px-4 dq-pt-5 dq-pb-4 sm:dq-p-6 sm:dq-pb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sm:dq-flex sm:dq-items-start"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("dq-mx-auto dq-flex-shrink-0 dq-flex dq-items-center dq-justify-center dq-h-12 dq-w-12 dq-rounded-full sm:dq-mx-0 sm:dq-h-10 sm:dq-w-10", iconBgClasses[type])
  }, icon[type]), /*#__PURE__*/_react.default.createElement("div", {
    className: "dq-mt-3 dq-text-center sm:dq-mt-0 sm:dq-ml-4 sm:dq-text-left"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "dq-text-lg dq-leading-6",
    id: "dialog-title"
  }, title), message && /*#__PURE__*/_react.default.createElement("div", {
    className: "dq-mt-2"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "dq-text-gray-500"
  }, message)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dq-mt-5 sm:dq-mt-4 sm:dq-flex sm:dq-flex-row-reverse"
  }, !hideCancelBtn && /*#__PURE__*/_react.default.createElement(_DqButton.default, {
    variant: "outline",
    size: "small",
    color: "gray",
    text: actionsCancelText,
    className: "dq-w-full sm:dq-ml-3 sm:dq-w-auto",
    onClick: !handleOnCancel ? handleAlertOnClose : handleAlertOnCancel
  }), /*#__PURE__*/_react.default.createElement(_DqButton.default, {
    size: "small",
    color: type,
    text: actionsConfirmText,
    className: "dq-w-full dq-mt-3 sm:dq-ml-3 sm:dq-mt-0 sm:dq-w-auto",
    onClick: handleAlertOnConfirm
  })))));
};

DqAlertDialog.defaultProps = {
  actionsCancelText: "Cancel",
  actionsConfirmText: "Confirm",
  backdropProps: {},
  hideCancelBtn: false,
  message: "",
  toggleEl: undefined,
  type: "error",
  handleOnClose: () => {},
  handleOnOpen: () => {}
};
var _default = DqAlertDialog;
exports.default = _default;